import ProjectStatsTab from "./sub_tabs/ProjectStatsTab";
import TimelineStatsTab from "./sub_tabs/TimelineStatsTab";


const adminOverViewTabRouter = {

  timeline_stats: 
  {
    title: 'Performance',
    element: <TimelineStatsTab />
  },

  project_stats: 
  {
    title: 'Projects',
    element: <ProjectStatsTab />
  },

}

export default adminOverViewTabRouter;